import { IClient, IClientConfig } from "./client.inteface";

/**
* Abstract Base Client Class
* Provides common implementation for all clients
*/
export abstract class BaseClient implements IClient {
    protected config: IClientConfig;

    constructor(config: IClientConfig) {
        this.config = config;
    }

    getConfig(): IClientConfig {
        return this.config;
    }
}